/**
 * @bigint-project/core
 *
 * 純 TypeScript 專案排程／資源／成本引擎。
 * 零 UI 相依、零 Node 相依 —— 必須能同時在瀏覽器與 Node 執行。
 *
 * 匯出分三層：
 * - `domain/`：領域模型契約（所有 agent 共用的型別來源）
 * - `engine/`：各引擎的輸入／輸出介面與函式簽章
 * - `testing/`：測試用 builder（正式程式碼請勿引用）
 */

export * from './domain/index.js';
export * from './engine/index.js';
export * from './io/index.js';
export * as fixtures from './testing/fixtures.js';

/** 領域模型契約版本。破壞性變更時遞增，供各 agent 對齊。 */
export const CORE_CONTRACT_VERSION = '1.2.0';
